import ProjectStatsComponent from './project-stats.component'

export default ProjectStatsComponent
